import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import Validated from 'components/util/Validated';

import { Form } from 'common/components';

import CompaniesSchemas from 'schemas/companies_schemas';

import RolePermissionsForm from 'roles/components/RolePermissionsForm';

const CompanyForm = ({
  errors = {},
  isLoading = false,
  isSubmitted = false,
  handleSubmit = () => {},
  handleValueChange = () => {},
  handleCheckPermission = () => {},
  handleClickPermissionRow = () => {},
  handleCheckSection = () => {},
  permissions = { bySection: {}, allSections: [] },
  t = (k) => k,
  values = { modules: '' },
}) => {
  const FieldCheckbox = ({ name, label, checked, onChange, error }) => (
    <div className="form-group mb-4">
      <div className="form-check form-switch d-flex align-items-center">
        <input
          type="checkbox"
          className={`form-check-input me-2 ${error && error.message ? 'is-invalid' : ''}`}
          id={name}
          name={name}
          checked={checked}
          onChange={(e) => onChange({ target: { name, value: e.target.checked } })}
        />
        <label className="form-check-label mb-0 mt-1" htmlFor={name}>
          {label}
        </label>
      </div>
      {error && error.message && <div className="invalid-feedback d-block">{error.message}</div>}
    </div>
  );

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
      noValidate
      autoComplete="false"
    >
      <div className="row mt-3 align-items-center">
        <div className="col-sm-6 col-md-4">
          <Form.FieldInput
            autoFocus={true}
            error={(isSubmitted && errors.shortname) || {}}
            name={'shortname'}
            label={t('companies.fields.shortname')}
            placeholder={t('companies.fields.shortname')}
            handleChange={handleValueChange}
            t={t}
            value={values.shortname}
          />
        </div>

        <div className="col-sm-6 col-md-4">
          <Form.FieldInput
            type={'number'}
            autoFocus={true}
            error={(isSubmitted && errors.adminsLimit) || {}}
            name={'adminsLimit'}
            label={t('companies.fields.adminsLimit')}
            placeholder={t('companies.fields.adminsLimit')}
            handleChange={handleValueChange}
            t={t}
            value={values.adminsLimit}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldInput
            type={'number'}
            autoFocus={true}
            error={(isSubmitted && errors.assetsLimit) || {}}
            name={'assetsLimit'}
            label={t('companies.fields.assetsLimit')}
            placeholder={t('companies.fields.assetsLimit')}
            handleChange={handleValueChange}
            t={t}
            value={values.assetsLimit}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldInput
            type={'number'}
            autoFocus={true}
            error={(isSubmitted && errors.filesPerAsset) || {}}
            name={'filesPerAsset'}
            label={t('companies.fields.filesPerAsset')}
            placeholder={t('companies.fields.filesPerAsset')}
            handleChange={handleValueChange}
            t={t}
            value={values.filesPerAsset}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldInput
            type={'number'}
            autoFocus={true}
            error={(isSubmitted && errors.sizePerFile) || {}}
            name={'sizePerFile'}
            label={t('companies.fields.sizePerFile')}
            placeholder={t('companies.fields.sizePerFile')}
            handleChange={handleValueChange}
            t={t}
            value={values.sizePerFile}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldDate
            autoFocus={true}
            label={t('companies.fields.initDate')}
            name={'initDate'}
            placeholder={t('companies.fields.initDate')}
            handleChange={handleValueChange}
            t={t}
            value={values.initDate}
          />
        </div>

        <div className="col-sm-6 col-md-4">
          <Form.FieldDate
            autoFocus={true}
            label={t('companies.fields.endDate')}
            name={'endDate'}
            placeholder={t('companies.fields.endDate')}
            handleChange={handleValueChange}
            t={t}
            value={values.endDate}
          />
        </div>

        <div className="col-sm-6 col-md-4">
          <Form.FieldInput
            type={'text'}
            autoFocus={true}
            error={(isSubmitted && errors.salesAgent) || {}}
            name={'salesAgentName'}
            label={t('companies.fields.salesAgentName')}
            placeholder={t('companies.fields.salesAgentName')}
            handleChange={handleValueChange}
            t={t}
            value={values.salesAgentName}
          />
        </div>

        <div className="col-sm-6 col-md-4">
          <Form.FieldInput
            type={'text'}
            autoFocus={true}
            error={(isSubmitted && errors.salesAgent) || {}}
            name={'salesAgentEmail'}
            label={t('companies.fields.salesAgentEmail')}
            placeholder={t('companies.fields.salesAgentEmail')}
            handleChange={handleValueChange}
            t={t}
            value={values.salesAgentEmail}
          />
        </div>

        <div className="col-sm-6 col-md-4">
          <FieldCheckbox
            name="isDemo"
            label={t('companies.fields.isDemo')}
            checked={values.isDemo}
            onChange={handleValueChange}
            error={(isSubmitted && errors.isDemo) || {}}
          />
        </div>

        <RolePermissionsForm
          t={t}
          bySection={permissions.bySection}
          allSections={permissions.allSections}
          handleCheckPermission={handleCheckPermission}
          handleClickPermissionRow={handleClickPermissionRow}
          handleCheckSection={handleCheckSection}
          // values={values.modules}
          values={values.modules}
        />

        {/* <div className="col-sm-6 col-md-4">
          <Form.FieldInput
            error={(isSubmitted && errors.name) || {}}
            name={"name"}
            label={t("companies.fields.name")}
            placeholder={t("companies.fields.name")}
            handleChange={handleValueChange}
            t={t}
            value={values.name}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.Checkbox
            name="active"
            className="icheckbox_flat-blue"
            onChange={handleValueChange}
            checked={values.active}
            label={t("common.active", { context: "female" })}
          />
        </div> */}
        <div className="col-md-12">
          <Form.Button
            text={t('actions.save')}
            isLoading={isLoading}
            extraClassName={'pull-right btn-xs-block'}
          />

          <Form.Link
            to={'/'}
            className={classnames('btn btn-secondary pull-right mr-3', {
              disabled: isLoading,
            })}
          >
            {t('actions.cancel')}
          </Form.Link>
          <div className="clearfix" />
        </div>
      </div>
    </form>
  );
};

export default Validated(CompaniesSchemas.edit)(translate()(CompanyForm));



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/components/CompanyFormRoot.js